import * as yup from 'yup';

export const OrgSchema = yup.object({
  id: yup.number(),
  name: yup.string(),
  api_phone: yup.string().nullable(),
  created_tsecs: yup.number().nullable(),
  master_id: yup.number().nullable(),
  type: yup.string().nullable(),
  paid: yup.boolean().nullable(),
  logo_file_id: yup.number().nullable(),
  is_manufacturer: yup.boolean().nullable(),
  warranty_claim_email: yup.string().nullable(),
});

export type Org = yup.InferType<typeof OrgSchema>;
